import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'
import { ADD_COMMENT } from 'root/src/shared/descriptions/endpoints/endpointIds'

export default formData => async (dispatch, getState) => {
	const state = getState()
	const projectUrl = currentRouteParamsRecordId(state)
	const apiPayload = {
		...formData,
		projectUrl,
	}

	return dispatch(apiRequest(ADD_COMMENT, apiPayload))
}
